// API клиент для Health Dashboard системы доступов RLS
import { apiClient } from './client'

// ---------------------------------------------------------------------------
// Types (соответствуют backend schemas в access_health.py)
// ---------------------------------------------------------------------------

export interface SyncCheckItem {
  name: string
  label: string
  /** ok | warning | error | info */
  status: string
  message: string
}

export interface LpuHealthItem {
  code: string
  name: string
  /** активных пользователей в ЛПУ (PG) */
  pg_users: number
  /** строк в CH mdc01_{code}.rls_access */
  ch_rows: number
  /** ok | warning | error | info */
  status: string
  note: string | null
}

export interface BiAuditOrgRef {
  id: string
  code: string
  name: string
}

export interface BiAuditEntryIssue {
  datalens_entry_id: string
  entry_title: string | null
  orgs: BiAuditOrgRef[]
  sources: string[]
}

export interface BiAuditUserIssue {
  user_id: string
  email: string
  full_name: string
  org: BiAuditOrgRef | null
  datalens_entry_id: string | null
  entry_title: string | null
  issue: string
  details: string
  visible_entry_count: number | null
  source_groups: string[]
}

export interface BiAccessAuditSummary {
  known_entries: number
  org_scoped_entries: number
  orphan_entries: number
  multi_org_entries: number
  direct_grants: number
  direct_grants_outside_user_org: number
  direct_grants_without_org_scope: number
  users_with_visible_bi_without_pg_rls: number
  checked_users: number
  scope: string
  truncated: boolean
}

export interface BiAccessAuditResponse {
  summary: BiAccessAuditSummary
  orphan_entries: BiAuditEntryIssue[]
  multi_org_entries: BiAuditEntryIssue[]
  direct_grant_issues: BiAuditUserIssue[]
  visible_without_pg_rls: BiAuditUserIssue[]
}

export interface AccessHealthResponse {
  sync_checks: SyncCheckItem[]
  lpu_health: LpuHealthItem[]
  bi_audit: BiAccessAuditResponse | null
  last_deploy_at: string | null
  checked_at: string
}

// ---------------------------------------------------------------------------
// API function
// ---------------------------------------------------------------------------

export const fetchAccessHealth = async (): Promise<AccessHealthResponse> => {
  const response = await apiClient.get<AccessHealthResponse>('/access-health/')
  return response.data
}
